import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Button } from 'semantic-ui-react';

const messages = defineMessages({
  uploadVideo: {
    id: 'uploadVideo',
    defaultMessage: 'Upload video or audio',
  },
});

const Edit = (props) => {
  const intl = useIntl();
  return (
    <div className="upload-video-button-container block">
      <Button color="blue">{intl.formatMessage(messages.uploadVideo)}</Button>
    </div>
  );
};

export default Edit;
